import {
  TextContent,
  ParentContent,
  OrderType,
  AnswerContent,
  SpaceContent,
  SpaceType,
} from '@/resource/question/question.type';
import parentExample from './add-parent';

const question1 = parentExample([
  new TextContent(
    'This is description of question 1. Lorem ipsum dolor sit amet',
  ),
  new AnswerContent(
    [new SpaceContent(SpaceType.Empty, 100, 200)],
    [new TextContent('This is answer for question 1')],
  ),
]);

const question2 = parentExample([
  new TextContent(
    'This is description of question 2 Lorem ipsum dolor sit amet',
  ),
  new AnswerContent(
    [new SpaceContent(SpaceType.Empty, 100, 200)],
    [new TextContent('This is answer for question 2')],
  ),
]);

const question3 = parentExample([
  new TextContent(
    'This is description of question 3 Lorem ipsum dolor sit amet',
  ),
  new AnswerContent(
    [new SpaceContent(SpaceType.Empty, 100, 200)],
    [new TextContent('This is answer for question 3')],
  ),
]);

const questionExample = new ParentContent(
  [question1, question2, question3],
  OrderType.Number,
);

export default questionExample;
